import { render, staticRenderFns } from "./ResultStep.vue?vue&type=template&id=92b08d98&scoped=true&"
import script from "./ResultStep.vue?vue&type=script&lang=js&"
export * from "./ResultStep.vue?vue&type=script&lang=js&"
import style0 from "./ResultStep.vue?vue&type=style&index=0&id=92b08d98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b08d98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
